<div class="modal-header">
    <h3 class="modal-title">Add RPA to Register</h3>
    <button
        type="button"
        (click)="modal.hide()"
        aria-label="Close"
        class="close"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="addToRegisterFormGroup" novalidate>
        <div class="form-group">
            <label for="authorityId" class="control-label">Authority</label>
            <ng-select
                [items]="authorities"
                bindLabel="name"
                bindValue="id"
                appendTo="body"
                [clearable]="false"
                formControlName="authorityId"
                placeholder="Select an authority"
                [loading]="loadingAuthorities"
                (change)="onAuthorityChange($event)"
            >
            </ng-select>
            <validation-messages
                [control]="addToRegisterFormGroup.controls.authorityId"
            ></validation-messages>
        </div>

        <div class="form-group">
            <label for="registerId" class="control-label">Register</label>
            <ng-select
                [items]="availableRegisters"
                bindLabel="name"
                bindValue="id"
                appendTo="body"
                [clearable]="false"
                formControlName="registerId"
                placeholder="Select a register"
                [disabled]="!addToRegisterFormGroup.get('authorityId').value"
                [loading]="loadingRegisters"
            >
            </ng-select>
            <validation-messages
                [control]="addToRegisterFormGroup.controls.registerId"
            ></validation-messages>
        </div>

        <div class="form-group">
            <label for="startDate" class="control-label">Start Date</label>
            <div class="input-group">
                <input
                    class="form-control"
                    #startDatePicker="bsDatepicker"
                    bsDatepicker
                    formControlName="startDate"
                />
                <span
                    class="input-group-addon btn-default"
                    (click)="startDatePicker.toggle()"
                    [attr.aria-expanded]="startDatePicker.isOpen"
                >
                    <i
                        class="glyphicon glyphicon-calendar"
                        style="cursor: pointer"
                    ></i>
                </span>
            </div>
            <validation-messages
                [control]="addToRegisterFormGroup.controls.startDate"
            ></validation-messages>
        </div>

        <div class="form-group">
            <label for="endDate" class="control-label">End Date</label>
            <div class="input-group">
                <input
                    class="form-control"
                    #endDatePicker="bsDatepicker"
                    bsDatepicker
                    formControlName="endDate"
                    [minDate]="addToRegisterFormGroup.get('startDate').value"
                />
                <span
                    class="input-group-addon btn-default"
                    (click)="endDatePicker.toggle()"
                    [attr.aria-expanded]="endDatePicker.isOpen"
                >
                    <i
                        class="glyphicon glyphicon-calendar"
                        style="cursor: pointer"
                    ></i>
                </span>
            </div>
            <validation-messages
                [control]="addToRegisterFormGroup.controls.endDate"
            ></validation-messages>
        </div>

        <div class="form-group">
            <label for="statusSource" class="control-label">Status</label>
            <ng-select
                [items]="statuses"
                bindLabel="name"
                bindValue="value"
                appendTo="body"
                [clearable]="false"
                formControlName="statusSource"
                placeholder="Status of this record"
            >
            </ng-select>
            <validation-messages
                [control]="addToRegisterFormGroup.controls.statusSource"
            ></validation-messages>
        </div>
    </form>
    <loading-indicator [isLoading]="working"></loading-indicator>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="modal.hide()">
        Cancel
    </button>
    <button
        type="button"
        class="btn btn-primary"
        (click)="onSave()"
        [disabled]="addToRegisterFormGroup.invalid || working"
    >
        <span *ngIf="working" class="fa fa-spinner fa-spin"></span>
        Add to Register
    </button>
</div>
